import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "antd";
import ResolutionSettingsIcon from "../../../../assets/resolution-setting-icon.svg";
function SettingDropdown(props) {
  const {parentId, isFullScreen, parentRef, isDownload} = props

const handleFullScreen = () => {
    const elem = parentRef?.current;

    if (parentRef?.current) {
      if (document.fullscreenElement) document.exitFullscreen();
      else elem.requestFullscreen();
    }
  };

  const items = [
    {
      label: (
        <div>
          <span className="font-face-vzw">Action</span>
        </div>
      ),
      key: "ats-setting-dropdown-action",
    }
  ];

  if(isFullScreen){
    items.push({
      label: (
        <button onClick={handleFullScreen} className="ats-text-btn" type="button">
          Fullscreen
        </button>
      ),
      key: "ats-setting-dropdown-fullscreen",
    })
  }

  if(isDownload){
    items.push({
      label: (
        <button className="ats-text-btn" type="button">
          Download as CSV
        </button>
      ),
      key: "ats-setting-dropdown-downloadcsv",
    },)
  }

  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
      getPopupContainer={() =>
        document.getElementById(`${parentId}`)
      }
    >
      <div>
        <img
          className="resolution-icon"
          src={ResolutionSettingsIcon}
          alt="resolution setting Icon"
        />
      </div>
    </Dropdown>
  );
}

SettingDropdown.propTypes = {
  parentId: PropTypes.string.isRequired,
  isFullScreen: PropTypes.bool,
  parentRef: PropTypes.any,
  isDownload: PropTypes.bool
}
export default SettingDropdown;
